import * as s from './styles';
import type { IQuoteProps } from './types';

const Quote = ({ attribution = '', quote, backgroundColor }: IQuoteProps) => (
  <s.QuoteFigure>
    <s.QuoteText $backgroundColor={backgroundColor} forwardedAs="blockquote" variant="paragraph2">
      {quote}
    </s.QuoteText>
    <s.Attribution forwardedAs="figcaption" variant="tagline">
      {attribution}
    </s.Attribution>
  </s.QuoteFigure>
);

export default Quote;
